var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.conversa.status !== "ENCERRADA"
    ? _c(
        "div",
        [
          _c(
            "validation-observer",
            { ref: "validation", attrs: { tag: "div" } },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "div",
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticClass: "paddin-5",
                                  class: _vm.verificaCampoComErro(errors),
                                  model: {
                                    value: _vm.possuiPosseMansaEPacifica,
                                    callback: function($$v) {
                                      _vm.possuiPosseMansaEPacifica = $$v
                                    },
                                    expression: "possuiPosseMansaEPacifica"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _c("span", [_vm._v("Sim")])
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _c("span", [_vm._v("Não")])
                                  ])
                                ],
                                1
                              ),
                              errors.length
                                ? _c("span", { staticClass: "help erro" }, [
                                    _vm._v("Campo obrigatório")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  381176308
                )
              })
            ],
            1
          ),
          _vm.possuiPosseMansaEPacifica
            ? _c(
                "div",
                { staticClass: "upload" },
                [
                  _c("app-documentos", {
                    attrs: {
                      maxSize: 20,
                      "valid-extensions": _vm.extensoes,
                      documentos: _vm.documentos,
                      tiposDocumentos: _vm.tiposDocumentos,
                      tiposDocumentosObrigatorios: [],
                      observer: this.$refs.validation,
                      isDocumentoImagex: true,
                      titulo: "Documentos do Interessado",
                      pecasTecnicas: true,
                      aba: "Interessado",
                      mensagemOutros: _vm.mensagemOutros
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "default" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "caixa-entrada" })
                    }
                  }
                },
                [_vm._v("Cancelar")]
              ),
              _c(
                "el-button",
                { attrs: { type: "success" }, on: { click: _vm.enviar } },
                [_vm._v("Enviar")]
              )
            ],
            1
          )
        ],
        1
      )
    : _c("div", [_vm._m(0)])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-content-texto-info" }, [
      _c("span", { staticClass: "card-content" }, [
        _vm._v("Dados já enviados ao ITERPA.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cd0144c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd0144c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppDocumentosPosseMansaEPacifica.vue
// module id = null
// module chunks = 